import { Box } from '@chakra-ui/react';
import { Alert, AlertDescription, AlertIcon, AlertTitle } from 'components/UI';
import { Errors, ErrorsProps } from 'components/common/Errors';

type ErrorPanelProps = ErrorsProps & {
  title?: string;
};

const ErrorPanel = ({ title = 'The following errors occurred', errors }: ErrorPanelProps) => (
  <Alert
    flexDir="row"
    alignItems="center"
    status="error"
    variant="subtle"
    justifyContent="flex-start"
    mb={4}
    px={8}
    py={6}
  >
    <AlertIcon w={7} h={7} mr={6} />

    <Box flex={1}>
      <AlertTitle color="black" mb={4}>
        {title}
      </AlertTitle>
      <Box overflowY="auto" maxH={100} w="full">
        <AlertDescription>
          <Errors errors={errors} />
        </AlertDescription>
      </Box>
    </Box>
  </Alert>
);

export default ErrorPanel;
